import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadStudent } from "../../lib/api/student";
import { deleteCompleteQuest } from "../../lib/api/completeQuest";
import { StudentDetailForm } from "../../components/student/StudentDetailForm";
import { EmptyBlank } from "../../components/common";

const Detail = () => {
  const { id } = useParams();
  const [student, setStudent] = useState();

  const requestLoadStudent = useCallback(async () => {
    const { data } = await loadStudent({ id: id });
    //console.log(data);
    setStudent(data);
  }, [id]);

  useEffect(() => {
    requestLoadStudent();
  }, [requestLoadStudent]);

  const handleRemove = async (e) => {
    const { id: completeQuestId, value: weekNumber } = e.target;

    if (completeQuestId && weekNumber) {
      const rsp = await deleteCompleteQuest({ id: completeQuestId });

      if (rsp.result) {
        requestLoadStudent(); // React Refresh을 제대로 이해 못해서 db로 부터 다시 데이타를 가져오는 것으로 수정하였습니다.
        alert("퀘스트를 미완성 상태로 만들었습니다.");
      }
    }
  };

  return (
    <div>
      <Container fluid="md">
        {student ? (
          <StudentDetailForm student={student} handleRemove={handleRemove} />
        ) : undefined}
        <EmptyBlank />
      </Container>
    </div>
  );
};

export default Detail;
